/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
// import { NextSeo } from 'next-seo';
import router, { NextRouter, withRouter } from 'next/router';
import { BASE_URL, CASE_STUDY_VARIANTS, EASING_VALUE, SEO_INFO } from 'libs/constants';
import { Layout } from 'components/templates/layout';
import { NextSeo } from 'next-seo';
import { Container } from 'components/organisms/container';
import { Row } from 'components/organisms/row';
import { Col } from 'components/organisms/col';
import { Heading } from 'components/atoms/heading';
import { MaskImage } from 'components/atoms/mask-image';
import { Card } from 'components/atoms/card';
import { BackButton } from 'components/atoms/back-button';
import { useMediaQuery } from 'libs/use-media-query';
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { InView } from 'react-intersection-observer';
import { Button } from 'components/atoms/button';
import { mapModifiers } from 'libs/component';

interface ProductListPageProps {
  router: NextRouter;
  lang?: string;
}

const productList = [
  {
    image: '/images/logos/rtgs.svg',
    title: 'Real Time Gross Settlement (RTGS)',
    description: 'Reliable excluding settlement risk, and efficient wholesale settlement at Central bank account ',
    link: '/products-list/rtgs',
  },
  {
    image: '/images/logos/rtp.svg',
    title: 'Real-Time Payments System (RTP)',
    description: 'Retail payment between customer accounts with emphasis on real-time payment & 24/7 availability',
    link: '/products-list/rtp',
  },
  {
    image: '/images/logos/csd.svg',
    title: 'Central Securities Depository (CSD)',
    description:
      'Develop not only bond market but also entire financial market by supplying funds with bond collateral',
    link: '/products-list/csd',
  },
  {
    image: '/images/logos/ach-bp.svg',
    title: 'ACH Bulk Payment (ACH-BP)',
    description:
      'Low-value payment with settlement risk management for Bulk transaction such as salary and tax payment',
    link: '/products-list/ach-bp',
  },
  {
    image: '/images/logos/cts.svg',
    title: 'Cheque Trancation System (CTS)',
    description:
      'Digital-based cheque exchange system to reduce the settlement risks and the workload of central bank staff.',
    link: '/products-list/cts',
  },
  {
    image: '/images/logos/gateway.svg',
    title: 'Gateway',
    description: 'Compatible with a wide variety of protocols & file formats, and many useful functions for Reconcile',
    link: '/products-list/gateway',
  },
  {
    image: '/images/logos/dashboard.svg',
    title: 'Dashboard',
    description: 'Risk and liquidity management tool with at-a-glance & user-friendly graphical interface',
    link: '/products-list/dashboard',
  },
  {
    image: '/images/logos/non-functional.svg',
    title: 'Non-functional specification',
    description: 'The advanced payment & settlement system is realized as a safe, stable, and secure system.',
    link: '/products-list/non-functional',
  },
];

/* const preloadList = [
  // HERO - JPG
  { rel: 'preload', href: '/images/products/hero-sp.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/products/hero-sp@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/products/hero.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/products/hero@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // HERO - WEBP
  {
    rel: 'preload',
    href: '/images/products/hero-sp.webp',
    type: 'image/webp',
    as: 'image',
    media: '(max-width: 768px)',
  },
  {
    rel: 'preload',
    href: '/images/products/hero-sp@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/products/hero.webp', type: 'image/webp', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/products/hero@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // LOGOS
  { rel: 'preload', href: '/images/logos/rtgs.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/rtp.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/csd.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/ach-bp.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/cts.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/gateway.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/dashboard.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/non-functional.svg', type: 'image/svg+xml', as: 'image' },
  // Case Study - JPG
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  // Case Study - WEBP
  {
    rel: 'preload',
    href: '/images/home/case-study.webp',
    type: 'image/webp',
    as: 'image',
    media: '(max-width: 768px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study.webp',
    type: 'image/webp',
    as: 'image',
    media: '(min-width: 769px)',
  },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.webp',
    type: 'image/webp',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
]; */

const ProductListPage: React.FC<ProductListPageProps> = () => {
  const PAGE_KEY = 'PRODUCT_LIST';
  const PAGE_SEO_INFO = (SEO_INFO as any)[PAGE_KEY] as any;
  const PAGE_URL = `${BASE_URL}/products-list`;
  const headRef = useRef(null);
  const imageRef = useRef(null);
  const isSP = useMediaQuery('(max-width: 768px)');

  const { scrollY } = useViewportScroll();
  const [pageScrollY, setPageScrollY] = useState(0);
  const [sectionDimensions, setSectionDimensions] = useState({
    head: 712,
    content: 1520,
    caseStudy: 720,
  });
  const contentSectionRef = useRef(null);
  const caseStudySectionRef = useRef(null);
  const [sectionPictureReveals, setSectionPictureReveals] = useState({
    head: false,
    content: false,
    caseStudy: false,
  });

  const viewPage = (path: string) => {
    router.push(path, path, { scroll: true });
  };

  useEffect(() => {
    scrollY.onChange(v => setPageScrollY(v));
  }, [scrollY]);

  useEffect(() => {
    const detectSectionDimension = () => {
      const headSectionEl = headRef.current as unknown as HTMLDivElement;
      const contentSectionEl = contentSectionRef.current as unknown as HTMLDivElement;
      const caseStudySectionEl = caseStudySectionRef.current as unknown as HTMLDivElement;

      if (headSectionEl) {
        const rect = headSectionEl.getBoundingClientRect();
        sectionDimensions.head = rect.height;
      }

      if (contentSectionEl) {
        const rect = contentSectionEl.getBoundingClientRect();
        sectionDimensions.content = rect.height;
      }

      if (caseStudySectionEl) {
        const rect = caseStudySectionEl.getBoundingClientRect();
        sectionDimensions.caseStudy = rect.height;
      }
      setSectionDimensions(sectionDimensions);
    };

    const handleResize = () => {
      detectSectionDimension();
    };

    detectSectionDimension();

    if (window) {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (window) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [sectionDimensions]);

  useEffect(() => {
    const handleResize = () => {
      const imageEl = imageRef.current as unknown as HTMLDivElement;
      if (imageEl) {
        const rect = imageEl.getBoundingClientRect();
        if (rect) {
          const headEl = headRef.current as unknown as HTMLDivElement;
          if (headEl) {
            headEl.style.height = isSP ? 'auto' : `${rect.height}px`;
          }
        }
      }
    };
    // wait for animation
    setTimeout(() => {
      handleResize();
    }, 500);
    if (window) {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (window) {
        window.addEventListener('resize', handleResize);
      }
    };
  }, [isSP]);

  const graphicVariants: any = {
    bottom: {
      enter: {
        opacity: 1,
        y: 0,
        x: isSP ? 0 : 540,
        transition: {
          duration: 3,
          staggerChildren: 0.25,
          // delayChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 50,
        x: 540,
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
  };

  const headParallaxScrollRange = [0, sectionDimensions.head];
  const headVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
          // delayChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    image: {
      enter: {
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.25,
        },
      },
      exit: {
        opacity: 0,
        scale: 1.2,
      },
    },
    content: {
      enter: {
        transition: {
          staggerChildren: 0.25,
          delayChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    text: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 2.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
    items: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          delay: 0.5,
          duration: 2.5,
          ease: EASING_VALUE,
          staggerChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  const contentParallaxScrollRange = [
    headParallaxScrollRange[0],
    headParallaxScrollRange[1] + sectionDimensions.content,
  ];
  const contentVariants = {
    root: {
      enter: isSP
        ? {}
        : {
            transition: {
              staggerChildren: 0.25,
              // delayChildren: 0.25,
            },
          },
      exit: isSP
        ? {}
        : {
            transition: { staggerChildren: 0.05, staggerDirection: -1 },
          },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 2.5,
          ease: EASING_VALUE,
          staggerChildren: 0.25,
          // delayChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
  };
  const caseStudyParallaxScrollRange = [
    contentParallaxScrollRange[0],
    contentParallaxScrollRange[1] + sectionDimensions.caseStudy,
  ];
  const caseStudyParallax = {
    heading: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    content: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    image: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    imageText: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
  };
  const caseStudyVariants = CASE_STUDY_VARIANTS;

  return (
    <Layout pageId={PAGE_URL}>
      <NextSeo
        title={PAGE_SEO_INFO.title}
        description={PAGE_SEO_INFO.description}
        openGraph={{
          type: 'website',
          url: PAGE_URL,
          title: PAGE_SEO_INFO.title,
          description: PAGE_SEO_INFO.description,
          site_name: SEO_INFO.HOME.title,
        }}
        // additionalLinkTags={preloadList}
      />
      <div className="p-product-list">
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            zIndex: 9999,
            color: 'red',
            display: 'none',
          }}
        >
          {pageScrollY} {JSON.stringify(sectionDimensions)}
        </div>
        <InView triggerOnce>
          {({ inView, ref }) => (
            <motion.div
              ref={ref}
              className="p-product-list__wrapper"
              initial={false}
              animate={inView ? 'enter' : 'exit'}
              variants={headVariants.root}
            >
              <motion.section ref={headRef} className="p-product-list__head">
                <div className="p-product-list__head-wrapper">
                  <motion.div ref={imageRef} className="p-product-list__head-image" variants={headVariants.image}>
                    <div className="p-product-list__head-image-wrapper">
                      <MaskImage
                        start={inView}
                        video={
                          <video muted={true} playsInline={true}>
                            <source type="video/webm" src="/videos/mask.webm" />
                            <source type="video/mp4" src="/videos/mask.mp4" />
                          </video>
                        }
                      >
                        <picture>
                          <source
                            type="image/jpg"
                            media="(max-width: 768px)"
                            srcSet="/images/products/hero-sp.jpg, /images/products/hero-sp@2x.jpg 2x"
                          />
                          <source
                            type="image/jpg"
                            media="(min-width: 769px)"
                            srcSet="/images/products/hero.jpg, /images/products/hero@2x.jpg 2x"
                          />
                          <source
                            type="image/webp"
                            media="(max-width: 768px)"
                            srcSet="/images/products/hero-sp.webp, /images/products/hero-sp@2x.webp 2x"
                          />
                          <source
                            type="image/webp"
                            media="(min-width: 769px)"
                            srcSet="/images/products/hero.webp, /images/products/hero@2x.webp 2x"
                          />
                          <img
                            src="/images/products/hero.webp"
                            srcSet="/images/products/hero.webp, /images/products/hero@2x.webp 2x"
                            alt="Products List"
                            width="710"
                            height="712"
                          />
                        </picture>
                      </MaskImage>
                    </div>
                  </motion.div>
                  <Container>
                    <Row>
                      <Col width={7} widthSP={4}></Col>
                      <Col width={4} widthSP={4}>
                        <motion.div className="p-product-list__head-text" variants={headVariants.content}>
                          <motion.div className="p-product-list__head-text-title" variants={headVariants.text}>
                            <Heading modifiers="dot" size="large">
                              Products List
                            </Heading>
                          </motion.div>
                          <motion.div className="p-product-list__head-text-description" variants={headVariants.text}>
                            Best combination of cutting edge products & finely tuned customization can be delivered
                            flexibly & expeditiously for match customer requirement & harmonization with existing system
                          </motion.div>
                        </motion.div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </motion.section>

              <motion.section
                ref={contentSectionRef}
                className="p-product-list__products"
                variants={headVariants.items}
              >
                <div className="p-product-list__products-wrapper">
                  <Container>
                    {[
                      [0, 1, 2],
                      [3, 4, 5],
                      [6, 7],
                    ].map((range, rindex) => (
                      <Row key={rindex}>
                        <Col width={1} widthSP={4}></Col>
                        <Col width={10} widthSP={4}>
                          <InView triggerOnce>
                            {({ inView: pInView, ref: pRef }) => (
                              <motion.div
                                ref={pRef}
                                className="p-product-list__products-list"
                                initial={false}
                                animate={isSP ? undefined : pInView ? 'enter' : 'exit'}
                                variants={contentVariants.root}
                              >
                                {productList
                                  .filter((_item, index) => range.indexOf(index) !== -1)
                                  .map((item, index) => (
                                    <InView key={index} triggerOnce>
                                      {({ inView: cInView, ref: cref }) => (
                                        <motion.div
                                          ref={cref}
                                          className={mapModifiers(
                                            'p-product-list__products-list-item',
                                            index % 3 === 0 && 'left',
                                            index % 3 === 1 && 'center',
                                            index % 3 === 2 && 'right'
                                          )}
                                          initial={false}
                                          animate={isSP ? (cInView ? 'enter' : 'exit') : undefined}
                                          variants={contentVariants.item}
                                        >
                                          <Card
                                            modifiers="large"
                                            image={item.image}
                                            title={item.title}
                                            description={item.description}
                                            onClick={() => viewPage(item.link)}
                                          />
                                        </motion.div>
                                      )}
                                    </InView>
                                  ))}
                              </motion.div>
                            )}
                          </InView>
                        </Col>
                        <Col width={1} widthSP={4}></Col>
                      </Row>
                    ))}
                  </Container>
                </div>
                <motion.div
                  className="p-product-list__graphic"
                  variants={graphicVariants.bottom}
                  initial="exit"
                  animate="enter"
                >
                  <svg width="840.405" height="1052.288" viewBox="0 0 840.405 1052.288">
                    <g id="Group_25729" data-name="Group 25729" transform="translate(-13.043 870.471) rotate(-75)">
                      <path
                        id="Path_22315"
                        data-name="Path 22315"
                        d="M75.395,60.57,90.509,0S43.841,19.043,0,40.57Z"
                        transform="translate(819.622 85.112)"
                        fill="#001e42"
                      />
                      <path
                        id="Path_22316"
                        data-name="Path 22316"
                        d="M111.017,0S79.506,55.727,63.539,87.428L0,85.57Z"
                        transform="translate(848.046 216.028)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22317"
                        data-name="Path 22317"
                        d="M134.507,56.5,105.649,0,0,95.981Z"
                        transform="translate(704.629 109.213)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22319"
                        data-name="Path 22319"
                        d="M54.59,0,0,97.5s56.615-61.02,85.877-84.264Z"
                        transform="translate(757.141 303.669)"
                        fill="#df1f1c"
                      />
                      <path
                        id="Path_22320"
                        data-name="Path 22320"
                        d="M207.448,62.756,238.019,0S96.46,59.028,0,113.644Z"
                        transform="translate(524.513 75.475)"
                        fill="#001976"
                      />
                      <path
                        id="Path_22321"
                        data-name="Path 22321"
                        d="M165.854,0,0,55.042,125.57,72.266Z"
                        transform="translate(599.96 250.336)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22322"
                        data-name="Path 22322"
                        d="M221.8,0,159.824,110.255,0,57.453Z"
                        transform="translate(526.39 161.622) rotate(42)"
                        fill="#8ea7cd"
                      />
                      <path
                        id="Path_22323"
                        data-name="Path 22323"
                        d="M96.217,0A1015.7,1015.7,0,0,0,0,74.638L221.8,17.223Z"
                        transform="translate(321.528 111.24)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22324"
                        data-name="Path 22324"
                        d="M95.148,0,0,78.612l255-25.74Z"
                        transform="translate(255.856 179.264)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22325"
                        data-name="Path 22325"
                        d="M191.23,0S137.858,64.107,122.04,88.745L0,19.327Z"
                        transform="translate(430.216 529.436)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22326"
                        data-name="Path 22326"
                        d="M131.7,71.021,80.721,0,0,156.015S71.577,104.525,131.7,71.021Z"
                        transform="translate(444.134 573.244)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22327"
                        data-name="Path 22327"
                        d="M78.716,0,0,71.915l71.605,103.6Z"
                        transform="translate(241.88 404.207)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22328"
                        data-name="Path 22328"
                        d="M146.3,40.908,76.194,0S22.747,48.851,0,72.3L82.463,99.989Z"
                        transform="translate(228.909 312.329)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22329"
                        data-name="Path 22329"
                        d="M177.586,0,0,51.3l191.921,73.819Z"
                        transform="translate(176.556 598.569)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22330"
                        data-name="Path 22330"
                        d="M133.854,59.3,79.7,0,0,95.081Z"
                        transform="translate(-49.169 423.907)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22331"
                        data-name="Path 22331"
                        d="M0,0,54.13,151.488S141.955,39.061,169.139,12.632Z"
                        transform="translate(102.504 85.516)"
                        fill="#8ea7cd"
                      />
                      <path
                        id="Path_22332"
                        data-name="Path 22332"
                        d="M8.594,0,0,95.5l109.057,71.659Z"
                        transform="translate(151.193 625.114)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22333"
                        data-name="Path 22333"
                        d="M180.418,0,0,38.208l101.7,33.7Z"
                        transform="translate(43.967 298.01)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3085"
                        data-name="Ellipse 3085"
                        cx="71.924"
                        cy="71.924"
                        rx="71.924"
                        ry="71.924"
                        transform="translate(429.62 223.728)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3086"
                        data-name="Ellipse 3086"
                        cx="98.95"
                        cy="98.95"
                        rx="98.95"
                        ry="98.95"
                        transform="translate(-32.992 22.343)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3088"
                        data-name="Ellipse 3088"
                        cx="73.232"
                        cy="73.232"
                        rx="73.232"
                        ry="73.232"
                        transform="translate(311.526 423.07)"
                        fill="#001976"
                      />
                    </g>
                  </svg>
                </motion.div>
              </motion.section>
            </motion.div>
          )}
        </InView>

        {/* <!-- CASE STUDY --> */}
        <InView triggerOnce>
          {({ inView, ref }) => (
            <motion.section
              ref={ref}
              className="o-section-case-study"
              initial={false}
              animate={inView ? 'enter' : 'exit'}
              variants={caseStudyVariants.root}
            >
              <Container>
                <Row>
                  <Col className="o-section-case-study__heading-col" width={1} widthSP={4}>
                    <motion.div
                      className="o-section-case-study__heading"
                      variants={caseStudyVariants.heading}
                      style={{ y: caseStudyParallax.heading }}
                    >
                      <Heading modifiers="dot">Case Study</Heading>
                    </motion.div>
                  </Col>
                  <Col className="o-section-case-study__text-col" width={5} widthSP={4}>
                    <motion.div
                      className="o-section-case-study__text"
                      variants={caseStudyVariants.content}
                      style={{ y: caseStudyParallax.content }}
                    >
                      <motion.h1 className="o-section-case-study__text-title" variants={caseStudyVariants.text}>
                        Contributing
                        <br />
                        to Advancement
                      </motion.h1>
                      <motion.p className="o-section-case-study__text-subtitle" variants={caseStudyVariants.text}>
                        An ASEAN Country
                      </motion.p>
                      <motion.div className="o-section-case-study__text-action" variants={caseStudyVariants.cta}>
                        <Button onClick={() => viewPage('/case-study')}>VIEW MORE</Button>
                      </motion.div>
                    </motion.div>
                  </Col>
                  <Col className="o-section-case-study__image-col" width={6} widthSP={4}>
                    <div className="o-section-case-study__image">
                      <motion.figure
                        className="o-section-case-study__image-item"
                        variants={caseStudyVariants.image}
                        onAnimationStart={() => {
                          sectionPictureReveals.caseStudy = false;
                          setSectionPictureReveals(sectionPictureReveals);
                        }}
                        onAnimationComplete={() => {
                          sectionPictureReveals.caseStudy = true;
                          setSectionPictureReveals(sectionPictureReveals);
                        }}
                        style={{ y: caseStudyParallax.image }}
                      >
                        <MaskImage
                          start={sectionPictureReveals.caseStudy}
                          video={
                            <video muted={true} playsInline={true}>
                              <source type="video/webm" src="/videos/mask.webm" />
                              <source type="video/mp4" src="/videos/mask.mp4" />
                            </video>
                          }
                        >
                          <picture>
                            <source
                              type="image/jpg"
                              media="(max-width: 768px)"
                              srcSet="/images/home/case-study-sp.jpg, /images/home/case-study-sp@2x.jpg 2x"
                            />
                            <source
                              type="image/jpg"
                              media="(min-width: 769px)"
                              srcSet="/images/home/case-study.jpg, /images/home/case-study@2x.jpg 2x"
                            />
                            <source
                              type="image/webp"
                              media="(max-width: 768px)"
                              srcSet="/images/home/case-study-sp.webp, /images/home/case-study-sp@2x.webp 2x"
                            />
                            <source
                              type="image/webp"
                              media="(min-width: 769px)"
                              srcSet="/images/home/case-study.webp, /images/home/case-study@2x.webp 2x"
                            />
                            <img
                              src="/images/home/case-study.webp"
                              srcSet="/images/home/case-study.webp, /images/home/case-study@2x.webp 2x"
                              alt="Case Study"
                              width="375"
                              height="420"
                            />
                          </picture>
                        </MaskImage>
                      </motion.figure>
                      <motion.i
                        className="o-section-case-study__image-text"
                        variants={caseStudyVariants.imageText}
                        style={{ y: caseStudyParallax.imageText }}
                      >
                        C
                      </motion.i>
                    </div>
                  </Col>
                </Row>
              </Container>
            </motion.section>
          )}
        </InView>
        {/* <!-- /CASE STUDY --> */}

        <section className="p-product-list__back">
          <BackButton path="/" />
        </section>
      </div>
    </Layout>
  );
};

export default withRouter(ProductListPage);
